<template>
    <div class="container-bak">
      <div class="row-bak d-flex-bak align-items-center-bak header_table align-center">
        <label class="col-4-bak" for="datetime"
        style="margin: 0px 10px 0px 0px">{{label}}{{ label != ""? ":": ""}}</label>
        <input name="datetime" type="hidden" v-model="selectedDates">
        <b-form-select
            v-model="selectedPreset"
            class="col-6-bak filter"
            style="width: auto;"
        >
            <option :value="null" selected :disabled="selectedValue == null">All</option>
            <option value="last-7" :disabled="selectedValue == 'last-7'">Last 7 Days</option>
            <option value="last-30" :disabled="selectedValue == 'last-30'">Last 30 Days</option>
            <option value="ytd" :disabled="selectedValue == 'ytd'">Year to Date</option>
            <option value="custom-range" disabled v-if="isCustomDateSelected">{{formattedCustomRange}}</option>
            <option value="custom">Custom dates</option>
          </b-form-select>
        <b-modal id="date-modal" class="date-modal" size="sm" v-model="dateModal" ok-title="Submit" @ok="isCustomDateSelected = true" title="Date Range Filter">
          <v-date-picker class="col-8-bak datepicker-wrap"
            style="width: 100%;"
            v-model="range"
            is-range
            :is-dark="true">
          </v-date-picker>
        </b-modal>
      </div>
    </div>
  </template>
  <style>
  @import "~@coreui/coreui-pro/dist/css/coreui.min.css";
  .datepicker-wrap {
    padding: 0px !important;
  }
  input {
    width: 100%;
  }
  </style>
  <script>
  import Vue from 'vue';
  import VCalendar from 'v-calendar'
  import { lastNDaysStart } from '@/assets/js/common';
  Vue.use(VCalendar);

  export default {
    name: 'datepicker',
    data() {
      return {
        isCustomDateSelected: false,
        selectedDates: {
          startDate: null,
          endDate: null
        },
        isDateSelected: false,
        selectedPreset: null,
        range: {
          start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          end: new Date(new Date().getFullYear(), new Date().getMonth(), 5)
        },
        dateModal: false,
        selectedValue: null,
        // Avoid emitting `changed` when we only mirror parent's `value="custom"` on init/sync.
        _syncingValueFromParent: false,
      }
    },
    props: {
      label: { type: String, default: '' },
      /** Preset from parent: 'last-7' | 'last-30' | 'ytd' | 'custom' | null (All) */
      value: { default: null },
      /** When value is "custom" from the parent, optional start/end for URL/deep-link sync (see visitors/responses). */
      initialRange: { type: Object, default: null },
    },
    computed: {
      formattedCustomRange() {
        if (!this.range.start || !this.range.end) return 'Custom dates';
        const fmt = d => `${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getDate()).padStart(2,'0')}/${d.getFullYear()}`;
        return `${fmt(this.range.start)}-${fmt(this.range.end)}`;
      }
    },
    methods: {
    },
    watch: {
       value: {
        immediate: true,
        handler(newValue) {
          // Parent stores the preset as "custom" but the <select> must use a ifferent value
          // (custom-range) for the display row so the user can open the modal again by choosing
          if (newValue === 'custom') {
            this._syncingValueFromParent = true;
            this.isCustomDateSelected = true;
            this.selectedValue = 'custom';
            this.selectedPreset = 'custom-range';
            if (this.initialRange && this.initialRange.start && this.initialRange.end) {
              const start = new Date(this.initialRange.start);
              const end = new Date(this.initialRange.end);
              this.range = { start, end };
              this.selectedDates.startDate = start;
              this.selectedDates.endDate = end;
            }
            this.$nextTick(() => { this._syncingValueFromParent = false; });
          } else {
            // Mounting (or the parent's `value` prop changing) with a plain preset
            // like 'last-30' must NOT re-emit 'changed' with a freshly-computed
            // "now"-based range below — the parent (e.g. this page was navigated to
            // from a Dashboard widget) may already hold the EXACT range that
            // widget's own count was just computed from. Re-emitting here would
            // silently overwrite it with a later "now", making this page disagree
            // with the widget by whatever arrived in the gap between the widget's
            // fetch and this component mounting. Same guard the 'custom' branch
            // above already used — just never extended to these presets.
            this._syncingValueFromParent = true;
            this.isCustomDateSelected = false;
            this.selectedPreset = newValue || null;
            this.selectedValue = newValue;
            this.$nextTick(() => { this._syncingValueFromParent = false; });
          }
        }
      },
      isCustomDateSelected: function() {
        if(this.isCustomDateSelected) {
          this.selectedDates.startDate = this.range.start;
          this.selectedDates.endDate = this.range.end;
          if (!this._syncingValueFromParent) {
            this.isDateSelected  = true;
          }
          // Switch to display mode: 'custom-range' is a different value from 'custom',
          // so next time the user selects 'Custom dates' the watcher fires and opens the modal.
          this.selectedPreset = 'custom-range';
        }
      },
      isDateSelected: function(value) {
        if(value == true || value == null) {
          this.$emit('changed', { startDate: this.selectedDates.startDate, endDate: this.selectedDates.endDate, selectedValue: this.selectedValue });
          this.isDateSelected = false;
        }
      },
      selectedPreset: function(newVal) {
        // 'custom-range' is an internal display state — dates are already set, nothing to recalculate.
        // selectedValue stays as 'custom' (set when user first selected 'custom').
        if (newVal === 'custom-range') {
          return;
        }
        this.selectedValue = newVal;
        this.isCustomDateSelected = false;
        // Every boundary here is computed in UTC, not the viewer's local time.
        // Admins are spread across US/UK/Australia — "Last 30 Days" has to mean
        // the same fixed window for all of them, not "midnight wherever I am."
        if (newVal == 'last-7' || newVal == 'last-30') {
          // Exactly N calendar days including today (see lastNDaysStart).
          const start = lastNDaysStart({ 'last-7': 7, 'last-30': 30 }[newVal]);
          const end = new Date();
          end.setUTCHours(23, 59, 59, 999);
          this.selectedDates.startDate = start;
          this.selectedDates.endDate = end;
          // Suppress the emit during the initial parent-driven sync (see the
          // `value` watcher above) — only a genuine user click on this preset
          // should trigger a re-fetch with a freshly-computed range.
          if (!this._syncingValueFromParent) {
            this.isDateSelected = true;
          }
        } else if (newVal == 'ytd') {
          const start = new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0));
          const end = new Date();
          end.setUTCHours(23, 59, 59, 999);
          this.selectedDates.startDate = start;
          this.selectedDates.endDate = end;
          if (!this._syncingValueFromParent) {
            this.isDateSelected = true;
          }
        } else if (newVal == 'custom') {
          // Always open the modal when user explicitly selects 'Custom dates'
          this.dateModal = true;
        } else if (newVal == null) {
          this.selectedDates.startDate = new Date(0);
          this.selectedDates.endDate = new Date();
          if (!this._syncingValueFromParent) {
            this.isDateSelected = true;
          }
        }
      }
    }
  };
  </script>
